import moment from 'moment';
import { FC } from 'react';
import { CloseButton, DialogSubTitle, DialogToolbar } from '../../../../shared/dialog/dialog.styles';
import { withApptRequestIvStatusDialogProvider } from '../../hooks/use-appt-request-iv-status-dialog/hoc';
import { useApptRequestIvStatusDialog } from '../../hooks/use-appt-request-iv-status-dialog/hook';
import { ApptRequestIvStatusDialog } from '../appt-request-iv-status-dialog';
import { ManuallyVerifiedButton } from '../shared/manually-verified-button';
import { BoldText } from '../styles';

const SelfPayDialog: FC = () => {
  const { opened, onClose, isLoading, ivSummary, appointmentRequest } = useApptRequestIvStatusDialog();

  return (
    <ApptRequestIvStatusDialog
      opened={opened}
      title={'Self Pay'}
      subtitle={
        <>
          <BoldText>{`${appointmentRequest?.patient?.firstName} ${appointmentRequest?.patient?.lastName}`}</BoldText>
          {ivSummary?.dateSubmitted && <>&nbsp;- {moment.utc(ivSummary.dateSubmitted).local().format('MMM D hA')}</>}
        </>
      }
    >
      <DialogSubTitle sx={{ margin: '30px 0 20px 0', display: 'block' }}>
        This patient will be paying out of pocket and will not be utilizing insurance.
      </DialogSubTitle>

      <DialogToolbar>
        <ManuallyVerifiedButton onSuccess={async () => onClose()} disabled={isLoading} />
        <CloseButton onClick={onClose} disabled={isLoading} />
      </DialogToolbar>
    </ApptRequestIvStatusDialog>
  );
};

export default withApptRequestIvStatusDialogProvider(SelfPayDialog);
